// Centres a page-level block on the shared 180rem column and keeps a gutter
// between the content and the viewport edges. The gutter only widens past
// 1440px because below that the listing grid needs the remaining width to fit
// four cards next to the filter sidebar.
export const pageContainer =
  'mx-auto w-full max-w-content px-[1.6rem] min-[1440px]:px-[4rem]';
